import React from 'react';
import { SummaryRow } from '../../../../Summary/SummaryRow';
import { VQ } from '../../../../../store/student/types';
import { IVisaPrepForm, IExclusionOrder } from '../../../../../types';
import { boolToYesNo } from '../../../../../utilities/formatting';
import { Box } from '@chakra-ui/react';
import { SummaryGroup } from '../../../../Summary/SummaryGroup';
import { useTranslation } from "react-i18next";

function VisaPrepAdditionalHistoryStep4Info(props: IVisaPrepForm) {
    const { t } = useTranslation('forms.visa');
  const renderExclusionOrders = () => {
    const allExclusionsOrders: React.ReactNode[] = [];
    if (props.exclusionOrders && props.exclusionOrders.length) {
      props.exclusionOrders.forEach((exclusion: IExclusionOrder, i: number) => {
        allExclusionsOrders.push(
          <SummaryGroup title={t('forms.visa:exclusionOrder', { i: i + 1 })} key={i}>
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.EXCLUSION_DATE}-${i}`}
              label={t('forms.visa:dateOfExclusion')}
              value={exclusion.exclusionDate}
            />
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.EXCLUSION_REASON}-${i}`}
              value={exclusion.reason}
              label={t('forms.visa:reasonForExclusion')}
            />
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.EXCLUSION_REFERENCE}-${i}`}
              value={exclusion.reference}
              label={t('forms.visa:referenceNumber')}
            />
          </SummaryGroup>,
        );
      });
    }
    return allExclusionsOrders;
  };
  return (
    <>
      <SummaryRow
        className={'visa-summary'}
        key={VQ.HAS_BEEN_TO_UK}
        label={t('forms.visa:haveYouEverBeenToTheUk')}
        value={boolToYesNo(props.hasBeenToUk)}
      />
      {props.hasBeenToUk ? (
        <>
          <SummaryRow
            className={'visa-summary'}
            key={VQ.HAS_NI_NUMBER}
            label={t('forms.visa:doYouHaveAUkNationalInsuranceNum')}
            value={boolToYesNo(props.hasNINumber)}
          />
          {props.hasNINumber && (
            <SummaryRow
              className={'visa-summary'}
              key={VQ.NI_NUMBER}
              value={props.niNumber}
              label={t('forms.visa:whatIsTheNumber')}
            />
          )}
          <SummaryRow
            className={'visa-summary'}
            key={VQ.HAS_RECEIVED_MEDICAL_TREATMENT}
            label={t('forms.visa:haveYouEverReceivedMedicalTreatm')}
            value={boolToYesNo(props.hasReceivedMedicalTreatment)}
          />
          <SummaryRow
            className={'visa-summary'}
            key={VQ.HAS_VOLUNTARILY_DEPARTED}
            label={t('forms.visa:haveYouEverVoluntarilyElectedToD')}
            value={boolToYesNo(props.hasVoluntarilyDeparted)}
          />
          <SummaryRow
            className={'visa-summary'}
            key={VQ.HAS_EXCLUSION_ORDER}
            label={t('forms.visa:haveYouReceivedOrHaveYouBeenSubj')}
            value={boolToYesNo(props.hasExclusionOrder)}
          />
          {props.hasExclusionOrder && (
            <>
              <SummaryRow
                className={'visa-summary'}
                label={t('forms.visa:howManyExclusionOrders')}
                value={props.exclusionOrders?.length ?? 0}
              />

              <Box as="ol" pl={8}>
                {renderExclusionOrders()}
              </Box>
            </>
          )}
        </>
      ) : null}
    </>
  );
}

export default VisaPrepAdditionalHistoryStep4Info;
